module.exports = __webpack_public_path__ + "static/media/sq_swift.c77c6f6d.png";